import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import TruncatedConeGeometry from './truncated-cone-geometry';

var CylinderGeometry =
/*#__PURE__*/
function (_TruncatedConeGeometr) {
  _inherits(CylinderGeometry, _TruncatedConeGeometr);

  function CylinderGeometry() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, CylinderGeometry);

    var _opts$radius = opts.radius,
        radius = _opts$radius === void 0 ? 1 : _opts$radius;
    return _possibleConstructorReturn(this, _getPrototypeOf(CylinderGeometry).call(this, Object.assign({}, opts, {
      bottomRadius: radius,
      topRadius: radius
    })));
  }

  return CylinderGeometry;
}(TruncatedConeGeometry);

export { CylinderGeometry as default };
//# sourceMappingURL=cylinder-geometry.js.map


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist/esm/geometry/cylinder-geometry.js
// module id = 622
// module chunks = 0